import { Controller } from "@hotwired/stimulus"

// Date limit rows in the field settings slideover (TASK-267.7): each row is
// a No limit / Today / A date choice, and the date picker only shows for
// "A date".
export default class extends Controller {
  limitChanged(event) {
    const row = event.target.closest("[data-answer-rules-target='limit']")
    const picker = row?.querySelector("[data-answer-rules-target='limitDate']")
    if (!picker) return

    picker.classList.toggle("hidden", event.target.value !== "date")
  }
}
